import { Injectable, signal, WritableSignal } from '@angular/core';
import { NavigationItem } from '@models/types/app/NavigationItem.type';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  // STATE
  public readonly history: WritableSignal<NavigationItem[]> = signal<NavigationItem[]>([]);
 
  // METHODS
  public next(view: NavigationItem): void {
    
    const previousView: NavigationItem | undefined = this.history().at(-1);                     // Conseguimos el último elemento del historial de navegación.

    if(previousView?.map_id === view.map_id || previousView?.view === AppViews.Seatmap) return; // Si el último elemento es el mismo mapa, o la ultima vista es también seatmap, no hacemos nada.
    
    this.history.update(history => [...history, view]);      
    
    // Actualizamos el historial de navegación añadiendo el nuevo elemento.

  }

  public back(): Promise<NavigationItem | undefined> {

    return new Promise<NavigationItem | undefined>((resolve) => {
      
      let previousView!: NavigationItem | undefined;      

      this.history.update( history => (
        previousView = history.length > 1 ? history.at(-2) : undefined,  // Definimos el valor de previousView antes de actualizar el estado
        history.length >= 1 ? history.slice(0, -1) : history             // Actualizamos historial
      ));

      resolve(previousView);
     
    });

  }

  public reset(): void {
    
    if(this.history().length) this.history.set([]);
    
  }
 
}
